import React, { Component } from "react";
import { Button, Input, TreeSelect, Modal, Upload, Switch, Icon } from "antd";
const typeListItem = [
  {
    title: "请选择",
    value: "",
    key: "0",
  },
  {
    title: "启用",
    value: "true",
    key: "1",
  },
  {
    title: "禁用",
    value: "false",
    key: "2",
  },
];
class AddSpecialColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      showPicture: null,
      storagePicture: null,
      name: this.props.name,
      shortName: this.props.shortName,
      enabled: this.props.enabled,
      top: this.props.top,
      titlePic: "",
    };
  }

  nameOnChange(e) {
    this.setState({
      name: e.target.value,
    });
  }
  shortNameOnChange(e) {
    this.setState({
      shortName: e.target.value,
    });
  }
  // 新增专栏
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    let obj = {
      showPicture: this.state.showPicture,
      storagePicture: this.state.storagePicture,
      name: this.state.name,
      shortName: this.state.shortName,
      enabled: this.state.enabled,
      top: this.state.top,
    };
    this.props.getAddColumns(obj);
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  onChange = () => {
    let top = this.state.top;
    this.setState({
      top: !top,
    });
  };

  // 取消封面图
  cancel = () => {
    this.setState({
      titlePic: "",
    });
  };
  render() {
    // 上传
    const { titlePic } = this.state;
    console.log(titlePic);
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">点击上传</div>
      </div>
    );

    return (
      <div>
        <Modal
          title="新增专题"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          visible={this.state.visible}
          width="800px"
          bodyStyle={{ height: "500px" }}
          footer={null}
        >
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "10px" }}>专栏封面</div>
              <div
                style={{ marginLeft: "50px", width: "102px", height: "102px" }}
              >
                <Upload
                  name="file"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="/cm-sites-pms/ueditor/control?action=uploadimage"
                  onChange={this.UploadImg}
                >
                  {titlePic === "" ? (
                    uploadButton
                  ) : (
                    <img
                      style={{ width: "102px", height: "102px" }}
                      src={titlePic}
                      alt=""
                    />
                  )}
                </Upload>
                <div
                  style={{
                    width: "100px",
                    color: "red",
                    marginLeft: "5px",
                    cursor: "pointer",
                  }}
                  onClick={this.cancel}
                >
                  【取消封面图】
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>专栏全称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入专栏全称(不超过40个字符)"
                  value={this.state.name}
                  onChange={(e) => this.nameOnChange(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>专栏简称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入专栏简称(不超过10个字符)"
                  value={this.state.shortName}
                  onChange={(e) => this.shortNameOnChange(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>状态</div>
              <div style={{ marginLeft: "78px" }}>
                <TreeSelect
                  searchPlaceholder="请选择"
                  style={{ width: "200px" }}
                  value={this.state.enabled}
                  treeData={typeListItem}
                  onChange={(value) => {
                    this.state.enabled = value;
                    this.setState({});
                  }}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>置顶</div>
              <div style={{ marginLeft: "78px" }}>
                <Switch onChange={this.onChange} checked={this.state.top} />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "50px",
              }}
            >
              <div>
                <Button type="primary" onClick={this.handleOk}>
                  保存
                </Button>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <Button type="primary" onClick={this.handleCancel}>
                  取消
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  // 上传
  UploadImg = (info) => {
    if (info.file.status === "done") {
      this.setState({
        titlePic: info.file.response.url,
      });
    }
  };
}


export default AddSpecialColumn;
